module.exports = __webpack_public_path__ + "Roboto-ThinItalic.588293290e86dad97fcf.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.woff
// module id = 133
// module chunks = 17